import { useState } from "react";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import ImageModal from "../../../helpers/ImageModal/ImageModal";
import { base_url } from "../../../services/configServices/config";

const FooterPublicLayout = () => {
  const image = useSelector((state) => state.meta?.image);
  const setting = useSelector((state) => state.meta?.setting);

  const [info, setInfo] = useState({});

  return (
    <>
      <div className="kf-footer">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-6 col-lg-3">
              {/* logo */}
              <div
                className="kf-logo element-anim-1 scroll-animate"
                data-animate="active"
              >
                <Link to="/">
                  <img
                    src={base_url + setting?.logo}
                    alt={`لوگو ${setting?.title}`}
                    style={{ maxHeight: 120 }}
                    className="rounded"
                  />
                </Link>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-3">
              {/* hours */}
              <div
                className="kf-f-hours element-anim-1 scroll-animate"
                data-animate="active"
              >
                <h5>ساعات کار</h5>
                <ul>
                  <li>
                    صبح ها
                    <em>{setting?.morningShift}</em>
                  </li>
                  <li>
                    عصر ها
                    <em>{setting?.eveningShift}</em>
                  </li>
                  <li>
                    <strong>هفت روز هفته</strong>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-3">
              {/* contact */}
              <div
                className="kf-f-contact element-anim-1 scroll-animate"
                data-animate="active"
              >
                <h5>تماس باما</h5>
                <ul>
                  <li>
                    <i className="las la-map-marker" />
                    <em>آدرس :</em>
                    {setting?.address}
                  </li>
                  <li>
                    <i className="las la-envelope-open-text" />
                    <em>پست الکترونیکی :</em>
                    info@cafebame.ir
                  </li>
                  <li>
                    <i className="las la-phone" />
                    <em>شماره تماس :</em>
                    <a href={`tel:${setting?.phoneNumber}`}>
                      {setting?.phoneNumber}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-lg-3">
              {/* gallery */}
              <div
                className="kf-f-gallery element-anim-1 scroll-animate"
                data-animate="active"
              >
                <h5>تصاویر {setting?.title}</h5>
                <ul>
                  {image?.gallery?.slice(0, 6).map((item, index) => (
                    <li key={index}>
                      <img
                        src={base_url + item}
                        alt={setting?.title}
                        onClick={() => setInfo(item)}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div
            className="kf-copyright element-anim-1 scroll-animate text-center"
            data-animate="active"
          >
            طراحی و توسعه توسط{" "}
            <a href="https://hamzehazizzadeh.ir/" target="_blank">
              حمزه عزیززاده
            </a>
          </div>
        </div>
      </div>

      <ImageModal
        isHeader={false}
        show={!isEmpty(info)}
        onHide={() => setInfo({})}
        title={info.title}
      >
        <img
          src={base_url + info.image}
          alt={info.title}
          style={{ height: "100%", width: "100%" }}
        />
      </ImageModal>
    </>
  );
};
export default FooterPublicLayout;
